import { CreatorsTile } from "../CreatorsTile/CreatorsTile";
import styles from "./CreatorsGrid.module.css";
export function CreatorsGrid({ creators }) {
    return (<div className={styles.grid} data-testid="creatorsGrid">
      {creators.map((creatorDisplayInfo, index) => (<div key={index} className={styles.item} data-testid="creatorsGridItem">
          <CreatorsTile creatorDisplayInfo={creatorDisplayInfo}/>
        </div>))}
    </div>);
}
